import { render, staticRenderFns } from "./LongTermReview.vue?vue&type=template&id=7afc7ab2&"
import script from "./LongTermReview.vue?vue&type=script&lang=js&"
export * from "./LongTermReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports